import { z } from "zod";
export const FigmaNodeRendererPayload = z.object({
    designSystemId: z.string(),
    versionId: z.string(),
    figmaNodePersistentIds: z.string().array(),
});
